import SuburbPestControlPage from "../components/SuburbPestControlPage";
import { IPSWICH_SUBURBS } from "../data/ipswichSuburbs";

export default function PestControlRaceviewPage() {
  return <SuburbPestControlPage suburb={IPSWICH_SUBURBS["raceview"]} />;
}
